// extracted by mini-css-extract-plugin
export default {"_":"menu____+sIEc","button":"menu_button__oUpX5","text":"menu_text__4OlN-"};